import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'
import { organizationShape } from '../user'

export const exportTemplateShape = {
  ...baseModelShape,
  name: z.string(),
  organization: z.string(),
  organizationRef: z.object(organizationShape).optional().nullable(),
  columnConfig: z.array(z.record(z.string(), z.any())).default([]),
}

export const exportTemplateCreateShape = {
  name: z.string(),
  organization: z.string(),
  columnConfig: z.array(z.record(z.string(), z.any())).optional(),
}

export const exportTemplateFilterShape = {
  organization: z.string(),
  search: z.string(),
}

export type ExportTemplate = GetInferredFromRaw<typeof exportTemplateShape>
export type ExportTemplateCreate = GetInferredFromRaw<typeof exportTemplateCreateShape>
export type ExportTemplateFilter = GetInferredFromRaw<typeof exportTemplateFilterShape>
